import { CallbackType as s } from "../auth/enums.js";
import { parseDeviceNameText as c, parseDisplayRecoveryCodesText as l } from "./script-parser.js";
class p {
  static getDeviceName(e) {
    const t = this.getDisplayCallback(e)?.getOutputByName("message", "") ?? "";
    return c(t);
  }
  /**
   * Retrieves the recovery codes by parsing the JavaScript message text in callback.
   *
   * @param step The step to evaluate
   * @return Recovery Code values in array
   */
  static getCodes(e) {
    const t = this.getDisplayCallback(e)?.getOutputByName("message", "");
    return l(t || "");
  }
  /**
   * Determines if the given step is a Display Recovery Codes step.
   *
   * @param step The step to evaluate
   * @return Is this step a Display Recovery Codes step
   */
  static isDisplayStep(e) {
    return !!this.getDisplayCallback(e);
  }
  /**
   * Gets the recovery codes step.
   *
   * @param step The step to evaluate
   * @return gets the Display Recovery Codes' callback
   */
  static getDisplayCallback(e) {
    return e.getCallbacksOfType(s.TextOutputCallback).find((t) => {
      const a = t.getOutputByName("message", void 0);
      return a && (a.includes("Recovery Codes") || a.includes("recovery codes"));
    });
  }
}
export {
  p as default
};
